export default "__VITE_ASSET__Fe1GoVYB__"